require("core-js/modules/es.array.reduce");

module.exports = function (e) {
  var r = {};

  function t(a) {
    if (r[a]) return r[a].exports;
    var n = r[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }

  return t.m = e, t.c = r, t.d = function (e, r, a) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: a
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (t.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var n in e) {
      t.d(a, n, function (r) {
        return e[r];
      }.bind(null, n));
    }
    return a;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 3);
}([function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.escapeRegExp = void 0, r.escapeRegExp = function (e) {
    return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  };
}, function (e, r, t) {
  "use strict";

  var a = this && this.__assign || function () {
    return (a = Object.assign || function (e) {
      for (var r, t = 1, a = arguments.length; t < a; t++) {
        for (var n in r = arguments[t]) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      n = this && this.__spreadArrays || function () {
    for (var e = 0, r = 0, t = arguments.length; r < t; r++) {
      e += arguments[r].length;
    }

    var a = Array(e),
        n = 0;

    for (r = 0; r < t; r++) {
      for (var i = arguments[r], o = 0, u = i.length; o < u; o++, n++) {
        a[n] = i[o];
      }
    }

    return a;
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.formatValue = void 0;
  var i = t(0),
      o = t(2);

  r.formatValue = function (e) {
    var r = e.value,
        t = e.decimalSeparator,
        n = e.intlConfig,
        c = e.decimalScale,
        f = e.prefix,
        d = void 0 === f ? "" : f,
        s = e.suffix,
        p = void 0 === s ? "" : s;
    if ("" === r || void 0 === r) return "";
    if ("-" === r) return "-";
    var v = new RegExp("^\\d?-" + (d ? i.escapeRegExp(d) + "?" : "") + "\\d").test(r),
        g = "." !== t ? u(r, t, v) : r,
        m = (n ? new Intl.NumberFormat(n.locale, n.currency ? {
      style: "currency",
      currency: n.currency,
      minimumFractionDigits: c || 0,
      maximumFractionDigits: 20
    } : void 0) : new Intl.NumberFormat(void 0, {
      minimumFractionDigits: c || 0,
      maximumFractionDigits: 20
    })).formatToParts(Number(g)),
        b = l(m, e),
        y = o.getSuffix(b, a({}, e)),
        h = r.slice(-1) === t ? t : "",
        S = (g.match(RegExp("\\d+\\.(\\d+)")) || [])[1];
    return void 0 === c && S && t && (b = b.includes(t) ? b.replace(RegExp("(\\d+)(" + i.escapeRegExp(t) + ")(\\d+)", "g"), "$1$2" + S) : y && !p ? b.replace(y, "" + t + S + y) : "" + b + t + S), p && h ? "" + b + h + p : y && h ? b.replace(y, "" + h + y) : y && p ? b.replace(y, "" + h + p) : [b, h, p].join("");
  };

  var u = function u(e, r, t) {
    var a = e;
    return r && "." !== r && (a = a.replace(RegExp(i.escapeRegExp(r), "g"), "."), t && "-" === r && (a = "-" + a.slice(1))), a;
  },
      l = function l(e, r) {
    var t = r.prefix,
        a = r.groupSeparator,
        i = r.decimalSeparator,
        o = r.decimalScale,
        u = r.disableGroupSeparators,
        l = void 0 !== u && u;
    return e.reduce(function (e, r, u) {
      var c = r.type,
          f = r.value;
      return "currency" === c && t ? n(e, [t]) : "group" === c ? l ? e : n(e, [void 0 !== a ? a : f]) : "decimal" === c ? void 0 !== o && 0 === o ? e : n(e, [void 0 !== i ? i : f]) : "fraction" === c ? n(e, [void 0 !== o ? f.slice(0, o) : f]) : "minusSign" === c && t ? [f, t] : t && 0 === u ? [t, f] : n(e, [f]);
    }, [""]).join("");
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.getSuffix = void 0;
  var a = t(0);

  r.getSuffix = function (e, r) {
    var t = r.groupSeparator,
        n = void 0 === t ? "," : t,
        i = r.decimalSeparator,
        o = void 0 === i ? "." : i,
        u = new RegExp("\\d([^" + a.escapeRegExp(n) + a.escapeRegExp(o) + "0-9]+)"),
        l = e.match(u);
    return l ? l[1] : void 0;
  };
}, function (e, r, t) {
  "use strict";

  var a = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var n = a(t(4));
  r.default = n.default;
  var i = t(1);
  Object.defineProperty(r, "formatValue", {
    enumerable: !0,
    get: function get() {
      return i.formatValue;
    }
  });
}, function (e, r, t) {
  "use strict";

  var a = this && this.__assign || function () {
    return (a = Object.assign || function (e) {
      for (var r, t = 1, a = arguments.length; t < a; t++) {
        for (var n in r = arguments[t]) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      n = this && this.__createBinding || (Object.create ? function (e, r, t, a) {
    void 0 === a && (a = t), Object.defineProperty(e, a, {
      enumerable: !0,
      get: function get() {
        return r[t];
      }
    });
  } : function (e, r, t, a) {
    void 0 === a && (a = t), e[a] = r[t];
  }),
      i = this && this.__setModuleDefault || (Object.create ? function (e, r) {
    Object.defineProperty(e, "default", {
      enumerable: !0,
      value: r
    });
  } : function (e, r) {
    e.default = r;
  }),
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var r = {};
    if (null != e) for (var t in e) {
      "default" !== t && Object.hasOwnProperty.call(e, t) && n(r, e, t);
    }
    return i(r, e), r;
  },
      u = this && this.__rest || function (e, r) {
    var t = {};

    for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (t[a] = e[a]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var n = 0;

      for (a = Object.getOwnPropertySymbols(e); n < a.length; n++) {
        r.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (t[a[n]] = e[a[n]]);
      }
    }

    return t;
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.CurrencyInput = void 0;
  var l = o(t(5)),
      c = t(6);
  r.CurrencyInput = l.forwardRef(function (e, r) {
    var t = e.allowDecimals,
        n = void 0 === t || t,
        i = e.allowNegativeValue,
        o = void 0 === i || i,
        f = e.id,
        d = e.name,
        s = e.className,
        p = e.customInput,
        v = e.decimalsLimit,
        g = e.defaultValue,
        m = e.disabled,
        b = void 0 !== m && m,
        y = e.maxLength,
        h = e.value,
        S = e.onValueChange,
        x = e.fixedDecimalLength,
        _ = e.placeholder,
        w = e.decimalScale,
        O = e.prefix,
        j = e.suffix,
        P = e.intlConfig,
        E = e.step,
        V = e.min,
        R = e.max,
        M = e.disableGroupSeparators,
        C = void 0 !== M && M,
        D = e.disableAbbreviations,
        N = void 0 !== D && D,
        A = e.decimalSeparator,
        I = e.groupSeparator,
        F = e.onChange,
        L = e.onFocus,
        T = e.onBlur,
        k = e.onKeyDown,
        K = e.onKeyUp,
        U = u(e, ["allowDecimals", "allowNegativeValue", "id", "name", "className", "customInput", "decimalsLimit", "defaultValue", "disabled", "maxLength", "value", "onValueChange", "fixedDecimalLength", "placeholder", "decimalScale", "prefix", "suffix", "intlConfig", "step", "min", "max", "disableGroupSeparators", "disableAbbreviations", "decimalSeparator", "groupSeparator", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp"]);
    if (A && I && A === I) throw new Error("decimalSeparator cannot be the same as groupSeparator");
    if (A && c.isNumber(A)) throw new Error("decimalSeparator cannot be a number");
    if (I && c.isNumber(I)) throw new Error("groupSeparator cannot be a number");

    var B = l.useMemo(function () {
      return c.getLocaleConfig(P);
    }, [P]),
        G = A || B.decimalSeparator || "",
        $ = I || B.groupSeparator || "",
        q = {
      decimalSeparator: G,
      groupSeparator: $,
      disableGroupSeparators: C,
      intlConfig: P,
      prefix: O,
      suffix: j
    },
        z = {
      decimalSeparator: G,
      groupSeparator: $,
      allowDecimals: n,
      decimalsLimit: v || x || 2,
      allowNegativeValue: o,
      disableAbbreviations: N,
      prefix: O
    },
        H = void 0 !== g ? c.formatValue(a(a({}, q), {
      decimalScale: w,
      value: String(g)
    })) : void 0 !== h ? c.formatValue(a(a({}, q), {
      decimalScale: w,
      value: String(h)
    })) : "",
        J = l.useState(H),
        Q = J[0],
        W = J[1],
        X = l.useState(!1),
        Y = X[0],
        Z = X[1],
        ee = l.useState(0),
        re = ee[0],
        te = ee[1],
        ae = r || l.useRef(null),
        ne = function ne(e, r) {
      Z(!0);
      var t = c.cleanValue(a({
        value: e
      }, z));
      if ("" === t) return S && S(void 0, d), void W("");

      if (!(y && t.replace(/-/g, "").length > y)) {
        if ("-" === t || t === G) return S && S(void 0, d), void W(e);
        var n = c.formatValue(a({
          value: t
        }, q));

        if (null != r) {
          var i = r + (n.length - e.length) || 1;
          te(i);
        }

        W(n), S && S(t, d);
      }
    };

    l.useEffect(function () {
      Y && "-" !== Q && ae && "object" == typeof ae && ae.current && ae.current.setSelectionRange(re, re);
    }, [re, ae, Y]);
    var ie = void 0 !== h ? c.formatValue(a(a({}, q), {
      decimalScale: Y ? void 0 : w,
      value: String(h)
    })) : void 0,
        oe = a({
      type: "text",
      inputMode: "decimal",
      id: f,
      name: d,
      className: s,
      onChange: function onChange(e) {
        var r = e.target,
            t = r.value,
            a = r.selectionStart;
        ne(t, a), F && F(e);
      },
      onBlur: function onBlur(e) {
        var r = e.target.value,
            t = c.cleanValue(a({
          value: r
        }, z));
        if ("-" === t || !t) return W(""), void (T && T(e));
        var n = c.fixedDecimalValue(t, G, x),
            i = c.padTrimValue(n, G, void 0 !== w ? w : x);
        S && S(i, d);
        var o = c.formatValue(a(a({}, q), {
          value: i
        }));
        W(o), T && T(e);
      },
      onFocus: function onFocus(e) {
        return L && L(e), Q ? Q.length : 0;
      },
      onKeyDown: function onKeyDown(e) {
        var r = e.key;

        if (E && ("ArrowUp" === r || "ArrowDown" === r)) {
          e.preventDefault(), te(Q.length);
          var t = parseFloat(void 0 !== h ? String(h).replace(G, ".") : c.cleanValue(a({
            value: Q
          }, z))) || 0,
              n = "ArrowUp" === r ? t + E : t - E;
          if (void 0 !== V && n < V) return;
          if (void 0 !== R && n > R) return;
          var i = String(E).includes(G) ? Number(String(E).split(G)[1].length) : void 0;
          ne(String(i ? n.toFixed(i) : n).replace(".", G));
        }

        k && k(e);
      },
      onKeyUp: function onKeyUp(e) {
        var r = e.key,
            t = e.currentTarget.selectionStart;

        if ("ArrowUp" !== r && "ArrowDown" !== r && "-" !== Q) {
          var a = c.getSuffix(Q, {
            groupSeparator: $,
            decimalSeparator: G
          });

          if (a && t && t > Q.length - a.length && ae && "object" == typeof ae && ae.current) {
            var n = Q.length - a.length;
            ae.current.setSelectionRange(n, n);
          }
        }

        K && K(e);
      },
      placeholder: _,
      disabled: b,
      value: void 0 !== ie && "-" !== Q && Q !== G ? ie : Q,
      ref: ae
    }, U);

    if (p) {
      var ue = p;
      return l.default.createElement(ue, a({}, oe));
    }

    return l.default.createElement("input", a({}, oe));
  }), r.CurrencyInput.displayName = "CurrencyInput", r.default = r.CurrencyInput;
}, function (e, r) {
  e.exports = require("react");
}, function (e, r, t) {
  "use strict";

  var a = this && this.__createBinding || (Object.create ? function (e, r, t, a) {
    void 0 === a && (a = t), Object.defineProperty(e, a, {
      enumerable: !0,
      get: function get() {
        return r[t];
      }
    });
  } : function (e, r, t, a) {
    void 0 === a && (a = t), e[a] = r[t];
  }),
      n = this && this.__exportStar || function (e, r) {
    for (var t in e) {
      "default" === t || r.hasOwnProperty(t) || a(r, e, t);
    }
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), n(t(7), r), n(t(11), r), n(t(1), r), n(t(12), r), n(t(2), r), n(t(13), r), n(t(14), r);
}, function (e, r, t) {
  "use strict";

  var a = this && this.__spreadArrays || function () {
    for (var e = 0, r = 0, t = arguments.length; r < t; r++) {
      e += arguments[r].length;
    }

    var a = Array(e),
        n = 0;

    for (r = 0; r < t; r++) {
      for (var i = arguments[r], o = 0, u = i.length; o < u; o++, n++) {
        a[n] = i[o];
      }
    }

    return a;
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.cleanValue = void 0;
  var n = t(8),
      i = t(9),
      o = t(10),
      u = t(0);

  r.cleanValue = function (e) {
    var r = e.value,
        t = e.groupSeparator,
        l = void 0 === t ? "," : t,
        c = e.decimalSeparator,
        f = void 0 === c ? "." : c,
        d = e.allowDecimals,
        s = void 0 === d || d,
        p = e.decimalsLimit,
        v = void 0 === p ? 2 : p,
        g = e.allowNegativeValue,
        m = void 0 === g || g,
        b = e.disableAbbreviations,
        y = void 0 !== b && b,
        h = e.prefix,
        S = void 0 === h ? "" : h;
    if ("-" === r) return r;

    var x = y ? [] : ["k", "m", "b"],
        _ = new RegExp("^\\d?-" + (S ? u.escapeRegExp(S) + "?" : "") + "\\d").test(r),
        w = RegExp("(\\d+)-?" + u.escapeRegExp(S)).exec(r) || [],
        O = w[0],
        j = w[1],
        P = S ? O ? r.replace(O, "").concat(j) : r.replace(S, "") : r,
        E = i.removeSeparators(P, l),
        V = o.removeInvalidChars(E, a([l, f], x)),
        R = V;

    if (!y) {
      if (x.some(function (e) {
        return e === V.toLowerCase();
      })) return "";
      var M = n.parseAbbrValue(V, f);
      M && (R = String(M));
    }

    var C = _ && m ? "-" : "";

    if (f && R.includes(f)) {
      var D = V.split(f),
          N = D[0],
          A = D[1],
          I = v && A ? A.slice(0, v) : A;
      return "" + C + N + (s ? "" + f + I : "");
    }

    return "" + C + R;
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.parseAbbrValue = r.abbrValue = void 0;
  var a = t(0);

  r.abbrValue = function (e, r, t) {
    if (void 0 === r && (r = "."), void 0 === t && (t = 10), e > 999) {
      var a = ("" + e).length,
          n = Math.pow,
          i = n(10, t);
      return a -= a % 3, (Math.round(e * i / n(10, a)) / i + " kMGTPE"[a / 3]).replace(".", r);
    }

    return String(e);
  };

  var n = {
    k: 1e3,
    m: 1e6,
    b: 1e9
  };

  r.parseAbbrValue = function (e, r) {
    void 0 === r && (r = ".");
    var t = new RegExp("(\\d+(" + a.escapeRegExp(r) + "\\d+)?)([kmb])$", "i"),
        i = e.match(t);

    if (i) {
      var o = i[1],
          u = i[3],
          l = n[u.toLowerCase()];
      return Number(o.replace(r, ".")) * l;
    }
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.removeSeparators = void 0;
  var a = t(0);

  r.removeSeparators = function (e, r) {
    void 0 === r && (r = ",");
    var t = new RegExp(a.escapeRegExp(r), "g");
    return e.replace(t, "");
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.removeInvalidChars = void 0;
  var a = t(0);

  r.removeInvalidChars = function (e, r) {
    var t = a.escapeRegExp(r.join("")),
        n = new RegExp("[^\\d" + t + "]", "gi");
    return e.replace(n, "");
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.fixedDecimalValue = void 0, r.fixedDecimalValue = function (e, r, t) {
    if (t && e.length > 1) {
      if (e.includes(r)) {
        var a = e.split(r),
            n = a[0];
        if ((i = a[1]).length > t) return "" + n + r + i.slice(0, t);
      }

      var i,
          o = e.length > t ? new RegExp("(\\d+)(\\d{" + t + "})") : new RegExp("(\\d)(\\d+)"),
          u = e.match(o);
      if (u) return "" + (n = u[1]) + r + (i = u[2]);
    }

    return e;
  };
}, function (e, r, t) {
  "use strict";

  var a = this && this.__assign || function () {
    return (a = Object.assign || function (e) {
      for (var r, t = 1, a = arguments.length; t < a; t++) {
        for (var n in r = arguments[t]) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.getLocaleConfig = void 0;
  var n = {
    currencySymbol: "",
    groupSeparator: "",
    decimalSeparator: ""
  };

  r.getLocaleConfig = function (e) {
    var r = e || {},
        t = r.locale,
        i = r.currency;
    return (t ? new Intl.NumberFormat(t, i ? {
      currency: i,
      style: "currency"
    } : void 0) : new Intl.NumberFormat()).formatToParts(1000.1).reduce(function (e, r) {
      return "currency" === r.type ? a(a({}, e), {
        currencySymbol: r.value
      }) : "group" === r.type ? a(a({}, e), {
        groupSeparator: r.value
      }) : "decimal" === r.type ? a(a({}, e), {
        decimalSeparator: r.value
      }) : e;
    }, n);
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.isNumber = void 0, r.isNumber = function (e) {
    return RegExp(/\d/, "gi").test(e);
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.padTrimValue = void 0, r.padTrimValue = function (e, r, t) {
    if (void 0 === r && (r = "."), void 0 === t || "" === e || void 0 === e) return e;
    if (!e.match(/\d/g)) return "";
    var a = e.split(r),
        n = a[0],
        i = a[1];
    if (0 === t) return n;
    var o = i || "";
    if (o.length < t) for (; o.length < t;) {
      o += "0";
    } else o = o.slice(0, t);
    return "" + n + r + o;
  };
}]);